import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'

export default {
  namespaced: true,

  state () {
    return {
      dateRange: {
        fromDate: '',
        toDate: ''
      },
      selectedDate: '',
      selectedDropdownDate: '',
      selectedFoundries: '',
      earningReportsLoading: false,
      earningReportsList: [],
      earningReportsSummary: {},
      scrollLoading: false,
      earningReportsTableFlag: false,
      sortProcessingLoader: false,
      showDateCalendar: false,
      filterDrop: true,
      totalListCount: 0,
      selected: '',
      paginationCurrentPage: 1
    }
  },

  getters: {
    getFilterDrop: state => {
      return state.filterDrop
    },
    getSelectedOption: state => {
      return state.selected
    },
    getDateCalendar: state => {
      return state.showDateCalendar
    },
    getSavedDateRange: state => {
      return state.dateRange
    },
    getSelectedDateRange: state => {
      return state.selectedDate
    },
    getFoundriesRange: state => {
      return state.selectedFoundries
    },
    getEarningReportsLoader: state => {
      return state.earningReportsLoading
    },
    getEarningReportList: state => {
      return state.earningReportsList
    },
    getEarningReportSummary: state => {
      return state.earningReportsSummary
    },
    getScrollLoader: state => {
      return state.scrollLoading
    },
    getEarningReportListTableFlag: state => {
      return state.earningReportsTableFlag
    },
    getSortProcessingLoader: state => {
      return state.sortProcessingLoader
    },
    getListCount: state => {
      return state.totalListCount;
    },
    getDateRangeDropdown: state => {
      return state.selectedDropdownDate
    },
    getPaginationCurrentPage: state => {
      return state.paginationCurrentPage;
    }
  },

  mutations: {
    setSavedDateRange (state, dateRange) {
      state.dateRange = dateRange
    },
    selectedDaterange (state, dateRange) {
      state.selectedDate = dateRange
    },
    foundriesSelected (state, foundriesRange) {
      state.selectedFoundries = foundriesRange
    },
    setEarningReportsLoader (state, value) {
      state.earningReportsLoading = value
    },
    setListData (state, list) {
      state.earningReportsList = [...list]
    },
    setEarningsReportSummary (state, data) {
      state.earningReportsSummary = data
    },
    setScrollLoader (state, value) {
      state.scrollLoading = value
    },
    setEarningReportsTableFlag (state, value) {
      state.earningReportsTableFlag = value
    },
    setSortProcessingLoader (state, value) {
      state.sortProcessingLoader = value
    },
    setListCount(state, value) {
      state.totalListCount = value
    },
    showDatePicker (state, value) {
      state.showDateCalendar = value
    },
    setDateRangeDropdown (state, dateRange) {
      state.selectedDropdownDate = dateRange
    },
    finalDropdownSelection(state, value) {
      state.selected = value
    },
    closeFilter (state, value) {
      state.filterDrop = value
    },
    setPaginationCurrentPage (state, value) {
      state.paginationCurrentPage = value
    }
  },

  actions: {
    getEarningReportSummary({ commit, state}, requestData) {
      return new Promise((resolve, reject) => {
        Api.SalesReport.getSalesReportSummary(requestData.userId, requestData.requestData)
        .then(response => {
          commit('setEarningsReportSummary', response.data)
          return resolve(response.data)
        })
        .catch((error) => {
          const err = Errors.create(error)
          reject(err)
        })
      })
    },
    getSalesReport ({ commit, state }, requestData) {
      return new Promise((resolve, reject) => {
        Api.SalesReport.getSalesReport(requestData.userId, requestData.requestData)
          .then(response => {
            commit('setSavedDateRange', requestData.requestData.filter.date)
            commit('setScrollLoader', false)
            commit('setListData', response.data.ordersList)
            commit('setListCount', response.data.totalRecords)
            return resolve(response.data)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('setScrollLoader', false)
            reject(err)
          })
      })
    },
    downSalesReportRequest ({ commit, state }, requestData) {
      return new Promise((resolve, reject) => {
        Api.SalesReport.downloadSalesReport(requestData.userId, requestData.requestData)
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            const err = Errors.create(error)
            reject(err)
          })
      })
    },
  },

  modules: {
    errors: VuexErrors
  }
}
